<template>
    <tbody class="orderItemsdesktop">
        <template v-for="order in orderlist">
            <tr
                v-show="filteredstatus.includes(order.order.status)"
                @click="expandedbox = expandedbox != order.id ? order.id : null"
                :key="order.id"
                :class="['orderDetails', order.order.status]"
            >
                <td>
                    <div class="deliveryInfo">
                        <div class="deliveryInfoItem deliveryUser">
                            <template v-if="order.assign_to.avatar">
                                <div
                                    :style="`background-image : url(${order.assign_to.avatar});`"
                                    class="deliveryImage"
                                ></div>
                            </template>

                            <template v-else>
                                <div class="deliveryImage">
                                    <b-icon icon="person"></b-icon>
                                </div>
                            </template>
                        </div>

                        <div class="deliveryInfoItem orderSize">
                            <span class="numberOrder">
                                {{ order.order.numberofboxes }}
                            </span>
                            <span class="doz"> DOZ </span>
                        </div>
                    </div>
                </td>

                <td>
                    {{ order.order.contact_name }}
                </td>

                <td>
                    {{ order.order.phone_number | VMask("(###) ###-####") }}
                </td>

                <td>
                    {{
                        order.order.order_event_time_range
                            ? `${order.order.order_event_time_range}, `
                            : ""
                    }}
                    {{ order.order.delivery_date | formatdate("MMM D") }}
                </td>

                <td>
                    <div class="deliveryInfo">
                        <b-row no-gutters>
                            <b-col cols="3">
                                <div
                                    class="googleMap"
                                    @click="openMap('point', order.order)"
                                >
                                    <GmapMap
                                        :options="mapOptions"
                                        :center="{
                                            lat: parseFloat(
                                                order.order
                                                    .shipping_address_latitude
                                            ),
                                            lng: parseFloat(
                                                order.order
                                                    .shipping_address_longitude
                                            ),
                                        }"
                                        :zoom="10"
                                        map-type-id="roadmap"
                                    >
                                        <GmapMarker
                                            :icon="svgMarker"
                                            :position="{
                                                lat: parseFloat(
                                                    order.order
                                                        .shipping_address_latitude
                                                ),
                                                lng: parseFloat(
                                                    order.order
                                                        .shipping_address_longitude
                                                ),
                                            }"
                                        />
                                    </GmapMap>
                                </div>
                            </b-col>

                            <b-col cols="9" >
                                <div class="deliveryDateandTime pl-3">
                                    <div class="dAddress">
                                        {{
                                            order.order.shipping_address_street
                                        }}
                                        {{ order.order.shipping_address_city }}
                                        {{ order.order.shipping_address_state }}
                                        {{
                                            order.order.shipping_address_zipcode
                                        }}
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </td>

                <td>
                    <template v-if="expandedbox == order.id">

                        <b-iconstack font-scale="2">
                            <b-icon
                                stacked
                                icon="chevron-up"
                                scale="0.5"
                            ></b-icon>
                            <b-icon stacked icon="circle"></b-icon>
                        </b-iconstack>
                    </template>

                    <template v-else>

                    <b-iconstack font-scale="2">
                        <b-icon
                            stacked
                            icon="chevron-down"
                            scale="0.5"
                        ></b-icon>
                        <b-icon stacked icon="circle"></b-icon>
                    </b-iconstack>
                    </template>
                </td>
            </tr>

            <tr v-if="expandedbox == order.id" :key="order.id + 'moredtails'" class="moredtailsrow">
                <td colspan="6">
                    <b-row class="pt-4">
                        <b-col cols="5">
                            <div class="orderTrail">
                                <div class="orderTrailItem">
                                    <span class="trailType done">
                                        <b-icon
                                            icon="file-earmark-text-fill"
                                        ></b-icon>
                                    </span>

                                    <div class="trailDetails">
                                        <h4>Order created</h4>
                                        <p>
                                            {{
                                                order.order.created_at
                                                    | forceformatdate(
                                                        "h:mm A, MMM D YYYY"
                                                    )
                                            }}
                                        </p>
                                    </div>
                                </div>

                                <div class="orderTrailItem">
                                    <span class="trailType done">
                                        <b-icon icon="person-fill"></b-icon>
                                    </span>

                                    <div class="trailDetails">
                                        <h4>
                                            Assigned to
                                            {{ order.assign_to.name }}
                                        </h4>
                                        <p>
                                            {{
                                                order.created_at
                                                    | forceformatdate(
                                                        "h:mm A, MMM D YYYY"
                                                    )
                                            }}
                                        </p>
                                    </div>

                                    <div
                                        @click="removeassignment(order)"
                                        class="trailAction"
                                        v-if="order.order.status == 'assign'"
                                    >
                                        <button
                                            :disabled="processing"
                                            class="btn btn-outline-primary"
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>

                                <div class="orderTrailItem">
                                    <span
                                        :class="[
                                            `trailType`,
                                            {
                                                done:
                                                    order.order.status !=
                                                    'assign',
                                            },
                                        ]"
                                    >
                                        <b-icon icon="check"></b-icon>
                                    </span>

                                    <div :class="[`trailDetails orderstatus`]">
                                        <h4>Accepted</h4>
                                        <template
                                            v-if="
                                                order.order.status != 'assign'
                                            "
                                        >
                                            <p>
                                                {{
                                                    accepteddate(order)
                                                        | forceformatdate(
                                                            "h:mm A, MMM D YYYY"
                                                        )
                                                }}
                                            </p>
                                        </template>

                                        <template v-else>
                                            <p>Pending</p>
                                        </template>
                                    </div>
                                </div>

                                <template
                                    v-for="(amend, index) in amendstatuses(
                                        order.order
                                    )"
                                >
                                    <div
                                        :key="index"
                                        class="orderTrailItem amendstatuses"
                                    >
                                        <span :class="[`trailType`, 'done']">
                                            <b-icon icon="pen-fill"></b-icon>
                                        </span>

                                        <div
                                            :class="[
                                                `trailDetails orderstatus`,
                                            ]"
                                        >
                                            <h4>Amended</h4>
                                            <p class="mb-0">
                                                {{
                                                    amend.created_at
                                                        | forceformatdate(
                                                            "h:mm A, MMM D YYYY"
                                                        )
                                                }}
                                            </p>
                                            <p>{{ amend.notes }}</p>
                                        </div>
                                    </div>
                                </template>

                                <div class="orderTrailItem">
                                    <span
                                        :class="[
                                            `trailType`,
                                            {
                                                done:
                                                    order.order.status ==
                                                    'delivered',
                                            },
                                        ]"
                                    >
                                        <b-icon icon="box-seam"></b-icon>
                                    </span>

                                    <div class="trailDetails">
                                        <h4>Delivered</h4>

                                        <template
                                            v-if="
                                                order.order.status ==
                                                'delivered'
                                            "
                                        >
                                            <p>
                                                {{
                                                    delivereddate(order)
                                                        | forceformatdate(
                                                            "h:mm A, MMM D YYYY"
                                                        )
                                                }}
                                            </p>
                                        </template>

                                        <template v-else>
                                            <p>
                                                ETA
                                                {{
                                                    order.order
                                                        .order_event_time_range
                                                        ? `${order.order.order_event_time_range}, `
                                                        : ""
                                                }}
                                                {{
                                                    order.order.delivery_date
                                                        | formatdate("MMM D")
                                                }}
                                            </p>
                                        </template>
                                    </div>
                                </div>

                                <div
                                    class="orderDelivered"
                                    v-if="order.order.status == 'delivered'"
                                >
                                    <div class="deliveredAction">
                                        <button
                                            v-if="checkiftoday(order)"
                                            @click="
                                                $emit('update:amend', order),
                                                    $bvModal.show('amendorder')
                                            "
                                            class="btn btn-outline-primary"
                                        >
                                            Amend
                                        </button>

                                        <button
                                            @click="confirmorder(order)"
                                            class="btn btn-primary"
                                        >
                                            CONFIRM
                                        </button>
                                    </div>

                                    <div class="deliveryProof">
                                        <img
                                            :src="getdeliverimg(order)"
                                            alt=""
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="orderContactDetails">
                                <div class="contactItem">
                                    <div class="orderNote">
                                        {{
                                            order.order.order_notes
                                                ? order.order.order_notes
                                                : "No notes"
                                        }}
                                    </div>
                                </div>
                            </div>
                        </b-col>

                        <b-col cols="5" offset="2">
                            <div class="orderSummary">
                                <div class="orderSummaryHeader">
                                    <b-row>
                                        <b-col cols="12">
                                            <h4>
                                                Order
                                                {{ order.order.order_number }}
                                                summary 

                                                <span class="dozen">
                                                    {{ order.order.numberofboxes }} Dozen
                                                </span>
                                            </h4>
                                        </b-col>

                                        <!-- <b-col cols="3 dozen">
                                            
                                        </b-col> -->
                                    </b-row>
                                </div>

                                <div class="orderBreakdown">
                                    <template
                                        v-for="(box, index) in grouporderbox(
                                            order.order.orderboxitems
                                        )"
                                    >
                                        <div
                                            :key="index"
                                            class="orderBreakdownItem"
                                        >
                                            <div
                                                class="orderboxheader"
                                            >
                                                <span class="orderNumber">{{
                                                    box.count
                                                }}</span>
                                                -
                                                <span class="boxname"
                                                    >{{ box.box_name }}
                                                </span>
                                               
                                            </div>

                                            <div
                                                class="flavorlist"
                                            >
                                                <template
                                                    v-for="(
                                                        flavor, flavorindex
                                                    ) in groupflavors(
                                                        box.flavors
                                                    )"
                                                >
            
                                                    <span :key="flavorindex">{{flavor.name}}</span>
                                                    <!-- <div
                                                        :key="index"
                                                        class="flavorname"
                                                    >
                                                        {{ flavor.name }}{{box.flavors.length == index+1 ? '' : ' ,'}}
                                                    </div> -->
                                                </template>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </td>
            </tr>

            <tr :key="order.id + 'space'" class="space">
                <td colspan="6"></td>
            </tr>
        </template>

       
    </tbody>
</template>

<script>
/**
 * Declerations
 */
// plugins
import axios from "axios";
import moment from "moment";

// helper
import Helper from "@/helpers/helper";

// mixins
import { orderboxmixins } from "@/mixins/orderboxmixins";
import { mapMixins } from "@/mixins/mapMixins";

export default {
    mixins: [orderboxmixins, mapMixins],
    props: {
        amend: {
            type: Object,
            default: () => null,
        },
        orderlist: {
            type: Array,
            default: () => [],
        },
        filteredstatus: {
            type: Array,
            default: () => [],
        },
        filtered: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            expandedbox: null,
            orderboxgroup: [],
            expandflavor: null,
            confirmingorder: null,
            processing: false,
        };
    },
    filters: {
        /**
         * Format date by
         * @param format
         */
        formatdate(date, format) {
            return date ? Helper.formatdate(date, format) : "";
        },
        /**
         * Force format date by
         * @param format
         */
        forceformatdate(date, format) {
            return date ? Helper.formatdate(date, format, true) : "";
        },
        /**
         * Format date by relation like
         * Today, Tomorrow, and MM/DD/YYYY
         */
        formatreldate(date) {
            return Helper.datestring(date);
        },
    },
    methods: {
        /**
         * Get amend statuses
         *
         */
        amendstatuses(order) {
            let amendlist = order.orderstatuses.filter((s) =>
                s.status.match(/amend/i)
            );

            return amendlist
                .slice()
                .sort(
                    (a, b) => new Date(a.updated_at) - new Date(b.updated_at)
                );
        },
        /**
         * Check if delivered today
         * then show amend button only when it delivered today
         */
        checkiftoday(order) {
            const deliverydate = this.delivereddate(order);

            return deliverydate
                ? moment(deliverydate).isSame(moment(), "day")
                : false;
        },
        /**
         * confirm order
         */
        async confirmorder(order) {
            this.$emit("removeassign", order.order_id);

            const url = `/update_order_status/${order.order_id}`;
            await axios.post(url, {
                status: "confirm",
            });
        },
        /**
         * Get delivery proof
         */
        getdeliverimg(order) {
            if (order.order.status == "delivered") {
                const status = order.order.orderstatuses.find(
                    (s) => s.status == "delivered"
                );
                console.log("deliveryimage", status);

                return status ? status.status_image : "";
            } else {
                return "";
            }
        },
        /**
         * Cancel order assignment
         */
        async removeassignment(order) {
            this.processing = true;
            const url = `/unassign_order/${order.order.id}`;
            await axios
                .post(url, { assign_to: order.assign_to.id })
                .catch((err) => console.log(err));
            this.processing = false;
            this.$emit("removeassign", order.order.id);
        },
        /**
         * Get accepted date
         */
        accepteddate(order) {
            const status = order.order.orderstatuses.find(
                (s) => s.status == "accepted"
            );

            return status ? status.created_at : "";
        },
        /**
         * Get delivered date
         */
        delivereddate(order) {
            const status = order.order.orderstatuses.find(
                (s) => s.status == "delivered"
            );

            return status ? status.created_at : "";
        },
        /**
         * Check order status
         *
         */
        checkdeliverystatus(order) {
            const [status] = order.order.orderstatuses;

            return status ? status.status : "";
        },
        /**
         * Group same flavors
         */
        groupflavors(flavors) {
            return flavors.filter(
                (value, index, self) =>
                    index ==
                    self.findIndex((t) => t.flavor_id == value.flavor_id)
            );
        },
        /**
         * Group order boxes and flavors
         */
        grouporderbox(orders) {
            const orderlist = Object.values(orders);

            const group = this.groupboxorder(orderlist);

            return group;
        },
    },
    beforeMount() {
        
    },
    /**
     * Run functions after component rendered
     */
    mounted() {
        // Google map
        this.$gmapApiPromiseLazy().then(() => {
            this.initMap();
        });
    },
};
</script>

<style lang="scss">
@import "@/scss/partials/_colors.scss";

.orderItemsdesktop {

    .vue-map-container {
        min-height: 60px;
        height    : 100%;
    }

    .orderTrail {
        .amendstatuses {
            svg {
                font-size: 14px;
            }

            .orderstatus {
                p {
                    text-transform: none;
                }
            }
        }
    }

    .orderDetails {
        border-left : 4px solid transparent;

        &.assign, &.pending {
            border-color : $primaryColor;
        }

        &.delivered {
            border-color: $green;
        }
    }

    .deliveryInfo {
        display: flex;
        align-items: center;
        margin-right: 15px;

        .deliveryInfoItem {
            width: 50px;
            height: 50px;
            border-radius: 100%;

            &.orderSize {
                background-color: $lightgrey3;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                margin-left: -10px;
                border: 2px solid white;

                span {
                    display: block;
                    font-weight: 800;

                    &:last-child {
                        font-size: 9px;
                    }
                }
            }

            &.deliveryUser {
                .deliveryImage {
                    width: 100%;
                    height: 100%;
                    border-radius: 100%;
                    background-size: cover;
                    background-position: center;
                }
            }
        }
    }

   


    .deliveryImage {
        svg {
            border-radius: 100%;
            width: 100%;
            height: 100%;
            border: 1px solid $grey;
            padding: 15px;
        }
    }

    .orderTrail {
        padding-left: 30px;

        .orderTrailItem {
            display: flex;
            border-left: 1px solid $lightgrey2;

            &:last-child {
                border: none;
            }

            .trailType {
                width: 50px;
                height: 50px;
                flex: 0 0 50px;
                margin-right: 15px;
                margin-left: -25px;
                border-radius: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: $lightgrey;
                font-size: 25px;

                &.done {
                    background-color: $primaryColor;
                    color: white;
                }
            }

            .trailDetails {
                h4 {
                    font-size: 18px;
                    font-weight: 700;
                    margin-bottom: 0;
                }

                p {
                    color : $grey;
                }
            }

            .trailAction {
                margin-left: auto;
                .btn {
                    width: 130px;
                    height: 40px;
                    padding: 0;
                }
            }
        }
    }

    .orderContactDetails {
        padding      : 15px 0;
        color        : $grey;

        .contactItem {
            margin-bottom: 10px;

            .orderNote {
                background-color: lighten($color: $primaryColor, $amount: 59);
                padding: 15px;
            }
        }
    }

    .orderSummary {
        padding-top: 30px;
        padding-right: 30px;

        .orderSummaryHeader {
            margin-bottom: 20px;

            h4 {
                font-size     : 18px;
                font-weight   : 800;
                margin-bottom : 0;
                text-transform: uppercase;

                .dozen {
                    text-transform: none;
                    font-weight   : 300;
                }
            }

            .dozen {
                font-weight: 800;
                color: $grey;
                text-align: left;
            }
        }

        .orderBreakdown {
            padding-left: 15px;

            .orderBreakdownItem {
                color: $primaryColor;
                font-size: 15px;
                margin-bottom: 10px;

                .orderNumber {
                    font-weight: 700;
                }
            }
        }
    }

    .orderDelivered {
        padding-top: 15px;
        padding-bottom: 15px;

        .deliveredAction {
            display: flex;
            margin-bottom: 30px;

            .btn {
                flex: 1;
                padding: 5px 0;
                height: initial;

                &:first-child {
                    margin-right: 10px;
                }

                &:last-child {
                    margin-left: 10px;
                }
            }
        }

        .deliveryProof {
            img {
                width: 100%;
                max-width: 200px;
                margin-left: auto;
                margin-right: auto;
                display: block;
            }
        }
    }

    .orderTrail {
        .orderstatus {
            p {
                text-transform: capitalize;
            }
        }
    }

    .card {
        p {
            font-size: 13px;
        }

        h4 {
            font-size: 18px;
        }

        header {
            padding-left: 15px;
            padding-right: 0;
        }
    }

    .orderBreakdown {
        .orderBreakdownItem {
            cursor: pointer;

            .orderboxheader {
                display: flex;
                align-items: center;

                .b-icon.bi {
                    font-size: 12px;
                }

                .orderNumber {
                    margin-right: 10px;
                }

                .boxname {
                    margin-left: 10px;
                    font-weight: 600;
                    margin-right: 10px;
                }
            }

            .flavorlist {
                padding-left: 30px;
                color : $grey;

                span {
                    &::after {
                        content: ', ';
                    }

                    &:last-child {
                        &::after {
                            display: none;
                        }
                    }
                }

              
            }
        }
    }

  
}
</style>
